import React, { FunctionComponent, PropsWithChildren } from 'react'
import cn from 'classnames'

import styles from './Group.module.scss'
import { Icon } from '@/icons'

interface GroupProps {
  className?: string
  bodyClassName?: string
  title: string
  number: string
  onShowTooltip?: () => void
}

export const Group: FunctionComponent<PropsWithChildren<GroupProps>> = ({
  className,
  bodyClassName,
  children,
  title,
  number,
  onShowTooltip,
}) => {
  return (
    <fieldset className={cn(className, styles.container)}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.number}>{number}.</span>
          <span className={styles.title}>{title}</span>
        </div>
        <button className={styles.helpButton} onClick={onShowTooltip}>
          <Icon name="info" className={styles.helpIcon} />
        </button>
      </div>
      <div className={cn(styles.body, bodyClassName)}>{children}</div>
    </fieldset>
  )
}
